import React from 'react';
import ChallengesPageShared from '../Challenges/ChallengesPageShared';

const ACSChallenges: React.FC = () => {
  return <ChallengesPageShared challengeType='ACS' />;
};

export default ACSChallenges;
